import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
// 
import {
  currentTenant,
  thousandsdisplay,
  userid,
  currency
} from "../../Common/Credentials";
import moment from "moment";
import { spin } from "../../Common/NewLoader.jsx";
import CustomToolbar from "../../CommonComponents/CustomToolbar";
import MUIDataTable from "mui-datatables";
import { salesid } from "../../Common/Permissions";
import Footer from "../../Component/Footer.js";
import Header from "../../Component/Header.js";
import Menu from "../../Component/Menu";
import InventoryService from "../InventoryService.js";
import { ThemeProvider } from "@mui/material";
import {
  createTheme,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
} from "@mui/material";
import IOSSwitch from "../../CommonComponents/IOSSwitch";
import PosService from "../../Sales/PointofSales/PosService";
import { NumericFormat } from "react-number-format";
import Swal from 'sweetalert2';

// Import CSS
import '../../NewUI/NewUI.css';
import Breadcrumb from "../../NewUI/NewComponents/Breadcrumb.jsx";

const theme = createTheme({
  overrides: {
    MuiTableCell: {
      head: {
        backgroundColor: "#e9ecef !important",
        border: [[1, "solid", "#ece6e6"]],
      },
      body: {
        border: [[1, "solid", "#ece6e6"]],
      },
    },
  },
});

class acceptingstockissueTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stockissue: [],
      acceptedstock: [],
      returnedstock: [],
      lossesdata: [],
      priceData: [],
      returned: false,
      accepted: true,
      lossesb: false,
      loading: false,
      comments: ["Damaged", "Shortage"],
      comment: "",
      losses: "",
      price: 0,
      // New UI state
      hovered: null,
      hoveredRow: null,
      isActionHovered: null,
      searchTerm: "",
      showSearch: false,
      isMobile: window.innerWidth <= 768,
      activeTab: 'accepted',
      sortConfig: { key: 'createdAt', direction: 'desc' },
    };
    this.refreshStocks = this.refreshStocks.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.sortData = this.sortData.bind(this);
  }

  // Sort indicator component
  SortIndicator = ({ columnKey }) => {
    if (this.state.sortConfig.key !== columnKey) {
      return <i className="fa fa-sort UI-sort-icon" />;
    }
    return this.state.sortConfig.direction === 'asc'
      ? <i className="fa fa-sort-up UI-sort-icon UI-sort-active" />
      : <i className="fa fa-sort-down UI-sort-icon UI-sort-active" />;
  }

  // Sorting function
  sortData(key) {
    let direction = 'asc';
    if (this.state.sortConfig.key === key && this.state.sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    this.setState({ sortConfig: { key, direction } });
  }

  getSortedData(data) {
    if (!this.state.sortConfig.key) return data;

    return [...data].sort((a, b) => {
      let aValue, bValue;

      switch (this.state.sortConfig.key) {
        case 'id':
          aValue = a.id || 0;
          bValue = b.id || 0;
          break;
        case 'itemname':
          aValue = a.itemname || '';
          bValue = b.itemname || '';
          break;
        case 'createdbyname':
          aValue = a.createdbyname || '';
          bValue = b.createdbyname || '';
          break;
        case 'receivedbyname':
          aValue = a.receivedbyname || '';
          bValue = b.receivedbyname || '';
          break;
        case 'acceptedquantity':
          aValue = Number(a.acceptedquantity) || 0;
          bValue = Number(b.acceptedquantity) || 0;
          break;
        case 'returnquantity':
          aValue = Number(a.returnquantity) || 0;
          bValue = Number(b.returnquantity) || 0;
          break;
        case 'createdAt':
          aValue = new Date(a.createdAt).getTime();
          bValue = new Date(b.createdAt).getTime();
          break;
        default:
          aValue = a[this.state.sortConfig.key] || '';
          bValue = b[this.state.sortConfig.key] || '';
      }

      if (aValue < bValue) {
        return this.state.sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return this.state.sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  escapeRegex(string) {
    if (!string) return '';
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlightSearchText(text, searchTerm) {
    if (!searchTerm?.trim() || !text) return text;

    const rawText = String(text);
    const escapedSearchTerm = this.escapeRegex(searchTerm);

    if (escapedSearchTerm.length > 50) {
      return rawText;
    }

    try {
      const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
      const parts = rawText.split(regex);

      return parts.map((part, index) =>
        regex.test(part)
          ? React.createElement('mark', {
            key: index,
            className: 'UI-search-highlight'
          }, part)
          : part
      );
    } catch (error) {
      console.warn('Regex error in search:', error);
      return rawText;
    }
  }

  formatCurrency(value) {
    if (value === null || value === undefined) return '0';

    const numericValue = typeof value === 'object' && value.parsedValue !== undefined ? value.parsedValue : value;

    const prefix = currency === "INR" ? "₹ " : currency === "USD" ? "$ " : currency + " ";

    return (
      <NumericFormat
        displayType="text"
        value={numericValue}
        decimalScale={2}
        fixedDecimalScale={true}
        thousandSeparator={true}
        thousandsGroupStyle={thousandsdisplay}
        prefix={prefix.trim()}
      />
    );
  }

  handleResize() {
    const isMobile = window.innerWidth <= 768;
    this.setState({ isMobile });
    if (!isMobile) {
      this.setState({ showSearch: false });
    }
  }

  handleAccepted = () => {
    this.setState({
      accepted: true,
      returned: false,
      lossesb: false,
      activeTab: 'accepted',
      searchTerm: "",
      sortConfig: { key: 'createdAt', direction: 'desc' }
    });
  };

  handlereturned = () => {
    this.setState({
      accepted: false,
      returned: true,
      lossesb: false,
      activeTab: 'returned',
      searchTerm: "",
      sortConfig: { key: 'createdAt', direction: 'desc' }
    });
  };

  handlelosses = () => {
    this.setState({
      accepted: false,
      returned: false,
      lossesb: true,
      activeTab: 'losses',
      searchTerm: "",
      sortConfig: { key: 'createdAt', direction: 'desc' }
    });
  };

  handleSearch(term) {
    this.setState({ searchTerm: term });
  }

  getFilteredData(data) {
    const { searchTerm } = this.state;
    if (!searchTerm.trim()) return data;

    const cleanSearch = searchTerm.replace(/[^\w]/g, '').toLowerCase();

    return data.filter((item) => {
      const checkFields = [
        item.id?.toString(),
        item.itemname,
        item.createdbyname,
        item.receivedbyname,
        item.whaddress,
        item.deptname,
        item.acceptedquantity?.toString(),
        item.returnquantity?.toString(),
        item.description,
      ];

      return checkFields.some((field) => {
        if (field === undefined || field === null) return false;

        const raw = String(field);
        const cleanField = raw.replace(/[^\w]/g, '').toLowerCase();

        return (
          cleanField.includes(cleanSearch) ||
          raw.toLowerCase().includes(searchTerm.toLowerCase())
        );
      });
    });
  }

  updateStockClicked(id) {
    this.props.navigate({
      pathname: `/updatestock`,
      state: {
        id: { id },
      },
    });
  }

  handleCommentChange = (e) => {
    this.setState({ comment: e.target.value });
  };

  handleAddLosses = (data) => {
    const acceptedItem = this.state.acceptedstock.find((e) => e.id === data);
    if (!acceptedItem) return;

    let lossesdata = {
      said: data,
      // batchid:this.state.acceptedstock.find((e) => e.id === data).batchid,
      itemid: acceptedItem.itemid,
      itemname: acceptedItem.itemname,
      quantity: this.state.losses,
      catid: acceptedItem.catid,
      uom: acceptedItem.uom,
      price: acceptedItem.cost,
      totalloss: acceptedItem.cost * parseFloat(this.state.losses),
      tenantid: currentTenant,
      comments: this.state.comment,
      deptid: acceptedItem.deptid,
      whid: acceptedItem.whid,
      createdby: userid,
      // store:this.state.id
    };

    PosService.NewPosLosses(lossesdata).then(() => {
      this.refreshStocks();
      Swal.fire({
        title: "Success!",
        text: "Losses added successfully",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#152f5f",
      });
    }).catch((error) => {
      console.error("Error adding losses:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to add losses",
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "#152f5f",
      });
    });
  };

  handlelossstatus = (data) => {
    const updatedStock = this.state.acceptedstock.map(item =>
      item.id === data ? { ...item, lossstatus: true } : item
    );
    this.setState({ acceptedstock: updatedStock });
  };

  handleclose = (data) => {
    const updatedStock = this.state.acceptedstock.map(item =>
      item.id === data ? { ...item, lossstatus: false } : item
    );
    this.setState({
      acceptedstock: updatedStock,
      losses: "",
      comment: ""
    });
  };

  refreshStocks() {
    this.setState({
      accepted: true,
      returned: false,
      lossesb: false,
      activeTab: 'accepted'
    });

    InventoryService.GetAcceptedStockIssue(currentTenant)
      .then((response) => {
        const sortedData = response.data.sort((a, b) =>
          a.createdAt < b.createdAt ? 1 : -1
        );

        const acceptedstock = sortedData.filter((e) => e.acceptedquantity > 0);
        const returnedstock = sortedData.filter((e) => e.returnquantity > 0);

        this.setState({
          stockissue: sortedData,
          acceptedstock: acceptedstock.map((e) => ({ ...e, lossstatus: false })),
          returnedstock: returnedstock,
          loading: false,
        });
      })
      .catch((e) => {
        if (e.response?.data?.error === "Unauthorized") {
          Swal.fire({
            title: "Your Session is Lost",
            text: "Please login back to resume",
            icon: "error",
            confirmButtonText: "OK",
            confirmButtonColor: "#152f5f",
          }).then(() => this.props.navigate(`/`));
        }
      });

    PosService.GetPosLosses(currentTenant).then((response) =>
      this.setState({ lossesdata: response.data })
    ).catch((error) => {
      console.error("Error fetching losses:", error);
    });

    PosService.GetPosPrices(currentTenant).then((response) =>
      this.setState({
        priceData: response.data,
        loading: false,
      })
    ).catch((error) => {
      console.error("Error fetching prices:", error);
    });
  }

  componentDidMount() {
    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      this.props.navigate(`/`);
    }

    if (window.innerWidth <= 768) {
      this.setState({ showSearch: true });
    }
    window.addEventListener('resize', this.handleResize);

    this.setState({ loading: true });
    this.refreshStocks();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  onquantityfocus() {
    document
      .getElementById("quantity")
      .addEventListener("mousewheel", function (event) {
        if (window.document.activeElement.type === "number") {
          event.preventDefault();
        }
      });
    document
      .getElementById("quantity")
      .addEventListener("keydown", function (e) {
        if (e.which === 38 || e.which === 40) {
          e.preventDefault();
        }
      });
  }

  renderTabs() {
    const { activeTab, acceptedstock, returnedstock, lossesdata } = this.state;

    const tabs = [
      { key: 'accepted', label: 'Accepted', count: acceptedstock.length },
      { key: 'returned', label: 'Returned', count: returnedstock.length },
      { key: 'losses', label: 'Losses', count: lossesdata.length },
    ];

    return (
      <div className="UI-quotation-tabs-container">
        {tabs.map((tab) => (
          <div
            key={tab.key}
            className={`UI-quotation-tab ${activeTab === tab.key ? 'UI-quotation-active-tab' : ''
              } ${this.state.hovered === `${tab.key}-tab`
                ? 'UI-quotation-tab-hovered'
                : ''
              }`}
            onClick={() => {
              if (tab.key === 'accepted') this.handleAccepted();
              else if (tab.key === 'returned') this.handlereturned();
              else if (tab.key === 'losses') this.handlelosses();
            }}
            onMouseEnter={() => this.setState({ hovered: `${tab.key}-tab` })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {tab.label}
            {tab.count > 0 && (
              <span className="UI-match-count">{tab.count}</span>
            )}
          </div>
        ))}
      </div>
    );
  }

  renderAcceptedTable() {
    const { acceptedstock, isMobile, searchTerm } = this.state;
    const filteredData = this.getFilteredData(acceptedstock);
    const sortedData = this.getSortedData(filteredData);

    if (sortedData.length === 0) {
      return (
        <div className={`UI-no-items-message ${isMobile ? 'UI-no-items-message-mobile' : ''}`}>
          {searchTerm ? 'No accepted stock found matching your search' : 'No accepted stock available'}
        </div>
      );
    }

    return (
      <div className={`UI-table-container ${isMobile ? 'UI-table-container-mobile' : ''}`}>
        <table className={`UI-table ${isMobile ? 'UI-table-mobile' : ''}`}>
          <thead className="UI-table-header">
            <tr>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'itemname' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('itemname')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Item Name
                  <this.SortIndicator columnKey="itemname" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'createdbyname' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('createdbyname')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Issued By
                  <this.SortIndicator columnKey="createdbyname" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'receivedbyname' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('receivedbyname')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Accepted By
                  <this.SortIndicator columnKey="receivedbyname" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
              >
                <div className="UI-th-content">
                  Warehouse
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
              >
                <div className="UI-th-content">
                  Department
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'acceptedquantity' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('acceptedquantity')}
                style={{ cursor: 'pointer', textAlign: 'right' }}
              >
                <div className="UI-th-content" style={{ justifyContent: 'flex-end' }}>
                  Quantity
                  <this.SortIndicator columnKey="acceptedquantity" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
              >
                <div className="UI-th-content">
                  Description
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'createdAt' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('createdAt')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Date
                  <this.SortIndicator columnKey="createdAt" />
                </div>
              </th>
              {(salesid === "2" || salesid === "3") && (
                <th className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`} style={{ textAlign: 'center' }}>
                  Actions
                </th>
              )}
            </tr>
          </thead>

          <tbody>
            {sortedData.map((item) => (
              <tr
                key={item.id}
                className={`UI-table-row ${isMobile ? 'UI-table-row-mobile' : ''} ${this.state.hoveredRow === item.id ? 'UI-table-row-hovered' : ''}`}
                onMouseEnter={() => this.setState({ hoveredRow: item.id })}
                onMouseLeave={() => {
                  this.setState({ hoveredRow: null, isActionHovered: null });
                }}
              >
                {/* Item Name */}
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-item-name ${this.state.hoveredRow === item.id ? 'UI-item-name-hover' : ''}`}>
                  {this.highlightSearchText(item.itemname, searchTerm)}
                </td>

                {/* Issued By */}
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {this.highlightSearchText(item.createdbyname, searchTerm)}
                </td>

                {/* Accepted By */}
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {this.highlightSearchText(item.receivedbyname, searchTerm)}
                </td>

                {/* Warehouse */}
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {this.highlightSearchText(item.whaddress, searchTerm)}
                </td>

                {/* Department */}
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {this.highlightSearchText(item.deptname, searchTerm)}
                </td>

                {/* Quantity */}
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`} style={{ textAlign: 'right' }}>
                  {this.highlightSearchText(item.acceptedquantity, searchTerm)}
                </td>

                {/* Description */}
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {this.highlightSearchText(item.description, searchTerm)}
                </td>

                {/* Date */}
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {moment(item.createdAt).format("DD-MM-YYYY HH:mm")}
                </td>

                {/* Losses Actions */}
                {(salesid === "2" || salesid === "3") && (
                  <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                    <div className="UI-action-buttons">
                      {item.lossstatus === true ? (
                        <div className="row" style={{ minWidth: '300px' }}>
                          <div className="col-md-12 mb-2">
                            <TextField
                              id="quantity"
                              type="number"
                              label="Loss Quantity"
                              size="small"
                              variant="outlined"
                              fullWidth
                              value={this.state.losses}
                              onChange={(e) => this.setState({
                                losses: e.target.value < 0 ? 0 : e.target.value
                              })}
                              error={this.state.losses > item.acceptedquantity}
                              helperText={this.state.losses > item.acceptedquantity ? "Exceeds available quantity" : ""}
                              onFocus={this.onquantityfocus}
                            />
                          </div>
                          <div className="col-md-12 mb-2">
                            <FormControl fullWidth size="small">
                              <InputLabel>Comments</InputLabel>
                              <Select
                                value={this.state.comment}
                                onChange={this.handleCommentChange}
                                label="Comments"
                              >
                                {this.state.comments.map((option) => (
                                  <MenuItem key={option} value={option}>
                                    {option}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                          <div className="col-md-12 d-flex">
                            <button
                              className="UI-btn UI-btn-primary tw-mr-1"
                              onClick={() => this.handleAddLosses(item.id)}
                              disabled={
                                !this.state.losses ||
                                this.state.losses === "" ||
                                this.state.losses === 0 ||
                                !this.state.comment ||
                                this.state.losses > item.acceptedquantity
                              }
                            > Save
                            </button>
                            <button
                              className="UI-btn UI-btn-outline"
                              onClick={() => this.handleclose(item.id)}
                            >Cancel
                            </button>
                          </div>
                        </div>
                      ) : (
                        <button
                          className={`UI-action-button UI-edit-button ${this.state.isActionHovered === `loss-${item.id}` ? 'UI-edit-button-hover' : ''}`}
                          onClick={() => this.handlelossstatus(item.id)}
                          onMouseEnter={() => this.setState({ isActionHovered: `loss-${item.id}` })}
                          onMouseLeave={() => this.setState({ isActionHovered: null })}
                        >
                          <Tooltip title="Add Losses" arrow>
                            <i className="fa fa-plus"></i>
                          </Tooltip>
                        </button>
                      )}
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderReturnedTable() {
    const { returnedstock, isMobile, searchTerm } = this.state;
    const filteredData = this.getFilteredData(returnedstock);
    const sortedData = this.getSortedData(filteredData);

    if (sortedData.length === 0) {
      return (
        <div className={`UI-no-items-message ${isMobile ? 'UI-no-items-message-mobile' : ''}`}>
          {searchTerm ? 'No returned stock found matching your search' : 'No returned stock available'}
        </div>
      );
    }

    return (
      <div className={`UI-table-container ${isMobile ? 'UI-table-container-mobile' : ''}`}>
        <table className={`UI-table ${isMobile ? 'UI-table-mobile' : ''}`}>
          <thead className="UI-table-header">
            <tr>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'itemname' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('itemname')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Item Name
                  <this.SortIndicator columnKey="itemname" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'createdbyname' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('createdbyname')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Issued By
                  <this.SortIndicator columnKey="createdbyname" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'receivedbyname' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('receivedbyname')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Accepted By
                  <this.SortIndicator columnKey="receivedbyname" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
              >
                <div className="UI-th-content">
                  Warehouse
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
              >
                <div className="UI-th-content">
                  Department
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'returnquantity' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('returnquantity')}
                style={{ cursor: 'pointer', textAlign: 'right' }}
              >
                <div className="UI-th-content" style={{ justifyContent: 'flex-end' }}>
                  Quantity
                  <this.SortIndicator columnKey="returnquantity" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
              >
                <div className="UI-th-content">
                  Description
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'createdAt' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('createdAt')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Date
                  <this.SortIndicator columnKey="createdAt" />
                </div>
              </th>
            </tr>
          </thead>

          <tbody>
            {sortedData.map((item) => (
              <tr
                key={item.id}
                className={`UI-table-row ${isMobile ? 'UI-table-row-mobile' : ''} ${this.state.hoveredRow === item.id ? 'UI-table-row-hovered' : ''}`}
                onMouseEnter={() => this.setState({ hoveredRow: item.id })}
                onMouseLeave={() => this.setState({ hoveredRow: null })}
              >
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-item-name ${this.state.hoveredRow === item.id ? 'UI-item-name-hover' : ''}`}>
                  {this.highlightSearchText(item.itemname, searchTerm)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {this.highlightSearchText(item.createdbyname, searchTerm)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {this.highlightSearchText(item.receivedbyname, searchTerm)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {this.highlightSearchText(item.whaddress, searchTerm)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {this.highlightSearchText(item.deptname, searchTerm)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`} style={{ textAlign: 'right' }}>
                  {this.highlightSearchText(item.returnquantity, searchTerm)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {this.highlightSearchText(item.description, searchTerm)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {moment(item.createdAt).format("DD-MM-YYYY HH:mm")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderLossesTable() {
    const { lossesdata, isMobile, searchTerm } = this.state;
    const filteredData = this.getFilteredData(lossesdata);
    const sortedData = this.getSortedData(filteredData);

    if (sortedData.length === 0) {
      return (
        <div className={`UI-no-items-message ${isMobile ? 'UI-no-items-message-mobile' : ''}`}>
          {searchTerm ? 'No losses found matching your search' : 'No losses recorded'}
        </div>
      );
    }

    return (
      <div className={`UI-table-container ${isMobile ? 'UI-table-container-mobile' : ''}`}>
        <table className={`UI-table ${isMobile ? 'UI-table-mobile' : ''}`}>
          <thead className="UI-table-header">
            <tr>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Item name
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
              >
                <div className="UI-th-content">
                  Price
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
              >
                <div className="UI-th-content">
                  UOM
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
              >
                <div className="UI-th-content">
                  Warehouse
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
              >
                <div className="UI-th-content">
                  Department
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
              >
                <div className="UI-th-content">
                  Quantity
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
              >
                <div className="UI-th-content">
                  Comments
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
              >
                <div className="UI-th-content">
                  Total
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'createdAt' ? 'UI-th-sorted' : ''}`}
                onClick={() => this.sortData('createdAt')}
                style={{ cursor: 'pointer' }}
              >
                <div className="UI-th-content">
                  Date
                  <this.SortIndicator columnKey="createdAt" />
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
              >
                <div className="UI-th-content">
                  Created By
                </div>
              </th>
              <th
                className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
              >
                <div className="UI-th-content">
                  Status
                </div>
              </th>
            </tr>
          </thead>

          <tbody>
            {sortedData.map((item) => (
              <tr
                key={item.id}
                className={`UI-table-row ${isMobile ? 'UI-table-row-mobile' : ''} ${this.state.hoveredRow === item.id ? 'UI-table-row-hovered' : ''}`}
                onMouseEnter={() => this.setState({ hoveredRow: item.id })}
                onMouseLeave={() => this.setState({ hoveredRow: null })}
              >
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-item-name ${this.state.hoveredRow === item.id ? 'UI-item-name-hover' : ''}`}>
                  {this.highlightSearchText(item.itemname, searchTerm)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`} style={{ textAlign: 'right' }}>
                  {this.formatCurrency(item.price)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {this.highlightSearchText(item.uom, searchTerm)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {this.highlightSearchText(item.warehouse, searchTerm)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {this.highlightSearchText(item.dept, searchTerm)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`} style={{ textAlign: 'right' }}>
                  {this.highlightSearchText(item.quantity, searchTerm)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {this.highlightSearchText(item.comments, searchTerm)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`} style={{ textAlign: 'right' }}>
                  {this.formatCurrency(item.totalloss)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {moment(item.createdAt).format("DD-MM-YYYY HH:mm")}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  {this.highlightSearchText(item.createdby, searchTerm)}
                </td>
                <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                  <span className={`UI-status-badge ${item.accstatus === 'Completed' ? 'UI-status-completed' :
                    item.accstatus === 'Processing' ? 'UI-status-pending' :
                      'UI-status-na'}`}>
                    {this.highlightSearchText(item.accstatus, searchTerm)}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderTable() {
    const { activeTab } = this.state;

    switch (activeTab) {
      case 'accepted':
        return this.renderAcceptedTable();
      case 'returned':
        return this.renderReturnedTable();
      case 'losses':
        return this.renderLossesTable();
      default:
        return this.renderAcceptedTable();
    }
  }

  render() {
    const { isMobile, showSearch, searchTerm, activeTab, loading } = this.state;

    return (
      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
          <div className={`UI-container ${isMobile ? 'UI-container-mobile' : ''}`}>
            <div className="UI-card">
              {/* Header */}
              <div className={`UI-header ${isMobile ? 'UI-header-mobile' : ''}`}>

              <Breadcrumb breadcrumbs={[{name:"Home",path:"/sales"},{name:"Stocks Acceptance",path:null}]}/>

                <div className={`UI-header-content ${isMobile ? 'UI-header-content-mobile' : ''}`}>
                  <div>
                    <h1 className={`UI-title ${isMobile ? 'UI-title-mobile' : ''}`}>
                      Stocks Acceptance
                    </h1>
                    <p className={`UI-subtitle ${isMobile ? 'UI-subtitle-mobile' : ''}`}>
                      Manage accepted, returned stocks and losses
                    </p>
                  </div>

                  <div className={`UI-header-actions ${isMobile ? 'UI-header-actions-mobile' : ''}`}>
                    {/* Mobile Search */}
                    {isMobile && (
                      <input
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => this.handleSearch(e.target.value)}
                        className="UI-mobile-search-input"
                      />
                    )}

                    <div className={`UI-buttons-row ${isMobile ? 'UI-buttons-row-mobile' : ''}`}>
                      {/* Desktop Search Toggle */}
                      {!isMobile && (
                        <div
                          className={`UI-search-container ${showSearch ? 'UI-search-container-expanded' : ''} ${this.state.hovered === "search" ? 'UI-search-container-hover' : ''}`}
                          onClick={() => {
                            if (!showSearch) this.setState({ showSearch: true });
                          }}
                          onMouseEnter={() => this.setState({ hovered: "search" })}
                          onMouseLeave={() => this.setState({ hovered: null })}
                        >
                          <i
                            className="fa fa-search UI-search-icon"
                          />
                          {!showSearch && "Search"}
                          {showSearch && (
                            <input
                              type="text"
                              placeholder="Search..."
                              value={searchTerm}
                              onChange={(e) => this.handleSearch(e.target.value)}
                              className="UI-search-input"
                              autoFocus
                              onClick={(e) => e.stopPropagation()}
                              onBlur={() => {
                                if (searchTerm.trim() === "") {
                                  this.setState({ showSearch: false });
                                }
                              }}
                            />
                          )}
                        </div>
                      )}

                      {/* New Stock Issue button - Only show for accepted tab and with permissions */}
                      {(salesid === "2" || salesid === "3") && activeTab === 'accepted' && (
                        <Link
                          as="button"
                          to={{
                            pathname: "/acceptingstockissue",
                            state: { id: -1, pagename: "Add Stock Issue" }
                          }}
                          className={`UI-btn UI-btn-primary ${this.state.hovered === "new" ? 'UI-btn-primary-hover' : ''} ${isMobile ? 'UI-btn-mobile' : ''}`}
                          onMouseEnter={() => this.setState({ hovered: "new" })}
                          onMouseLeave={() => this.setState({ hovered: null })}
                        >
                          <i className="fa fa-plus" /> {isMobile ? "New" : "New Stock Issue"}
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {loading ? (
                <div className="UI-loading-container">
                  {spin}
                </div>
              ) : (
                <>
                  {this.renderTabs()}
                  <div style={{ marginTop: '16px' }}>
                    {this.renderTable()}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
export default withRouter(acceptingstockissueTable);